module.exports = __webpack_public_path__ + "static/img/xinwenxiangqing_title.e3f7e23.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/xinwenxiangqing_title.png
// module id = 7wSv
// module chunks = 0